<template>
  <div class="svg-container">
    <div class="sun">
      <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
        viewBox="0 0 261 261" style="enable-background:new 0 0 261 261;" xml:space="preserve">
        <g id="Ring" class="ring">
          <path class="st0" d="M130.5,261C58.5,261,0,202.5,0,130.5S58.5,0,130.5,0S261,58.5,261,130.5S202.5,261,130.5,261z M130.5,13.5
            c-64.5,0-117,52.5-117,117c0,64.5,52.5,117,117,117c64.5,0,117-52.5,117-117C247.5,66,195,13.5,130.5,13.5z"/>
          <path class="st1" d="M130.5,3C60.2,3,3,60.2,3,130.5S60.2,258,130.5,258S258,200.8,258,130.5S200.8,3,130.5,3z M130.5,250.5
            c-66.2,0-120-53.8-120-120c0-66.2,53.8-120,120-120c66.2,0,120,53.8,120,120C250.5,196.7,196.7,250.5,130.5,250.5z"/>
        </g>
        <g id="Border">
          <circle class="st2" cx="130.5" cy="130.5" r="102"/>
        </g>
        <g id="Circle">
          <circle class="st3" cx="130.5" cy="130.5" r="97"/>
        </g>
      </svg>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Sun'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .svg-container {
    position: absolute;
    top: 0;
    z-index: 0;
    width: 100%;
    height: 100%;
  }

  .svg-container,
  .svg-container * {
    overflow: visible !important;
  }

  .sun {
    position: absolute;
    right: 10vw;
    width: 24vw;
    bottom: 29vw;
  }

  .sun svg {
    background: rgba(255, 238, 0, 0.4);
    border-radius: 50%;
    -webkit-box-shadow: 0px 0px 59px 0px rgba(255,238,0,1);
    -moz-box-shadow: 0px 0px 59px 0px rgba(255,238,0,1);
    box-shadow: 0px 0px 59px 0px rgba(255,238,0,1);
  }
  .st0{fill:#FEEA69;}
  .st1{fill:#FFF5BA;}
  .st2{fill:#FFF091;}
  .st3{fill:#FEDB00;}

</style>



// WEBPACK FOOTER //
// src/components/Background/Sun.vue